module.exports = __webpack_public_path__ + "static/media/clap.39f9581a.wav";